import React, { Fragment } from 'react';
import { Row, Col } from 'antd';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { Detail } from './components/Detail';

const DetailCustomer = ({ disabled }) => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[
            { name: 'Quản lý khách hàng', path: '/customers' },
            { name: 'Chi tiết khách hàng' }
          ]}
        />
      </div>
      <Row>
        <Col span={24}>
          <Detail disabled={disabled} />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default DetailCustomer;
